<ngb-pagination
  [maxSize]="maxSize"
  [collectionSize]="collectionSize"
  [(page)]="page"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
  [boundaryLinks]="true"
/>

<hr />
<div class="data-info-section">
  <span>Current page: {{ page }}</span>
  <span>Total records: {{ collectionSize }}</span>
</div>
